import { useMemo, useState } from 'react';
import './asma.css';

const MAX_NO_CLICKS = 6;

function Asma() {
  const [noClicks, setNoClicks] = useState(0);
  const [accepted, setAccepted] = useState(false);
  const floatingHearts = Array.from({ length: 140 });

  const yesScale = useMemo(() => {
    if (noClicks >= MAX_NO_CLICKS) {
      return 8;
    }

    return 1 + noClicks * 0.28;
  }, [noClicks]);

  const noScale = useMemo(() => {
    if (noClicks >= MAX_NO_CLICKS) {
      return 0;
    }

    return Math.max(0.12, 1 - noClicks * 0.16);
  }, [noClicks]);

  const noHidden = noClicks >= MAX_NO_CLICKS;

  const handleNo = () => {
    setNoClicks((prev) => Math.min(MAX_NO_CLICKS, prev + 1));
  };

  if (accepted) {
    return (
      <section className="asma asma-celebration">
        <div className="asma-stars" aria-hidden="true" />
        <div className="asma-hearts" aria-hidden="true">
          {floatingHearts.map((_, index) => (
            <span
              key={index}
              className="asma-heart"
              style={{
                left: `${4 + index * 7}%`,
                animationDelay: `${(index % 7) * 0.45}s`,
                animationDuration: `${5.8 + (index % 5) * 0.7}s`
              }}
            >
              &#10084;
            </span>
          ))}
        </div>
        <div className="asma-rockets" aria-hidden="true">
          {Array.from({ length: 12 }).map((_, index) => (
            <div
              key={index}
              className="asma-rocket"
              style={{
                left: `${6 + index * 8}%`,
                animationDelay: `${(index % 6) * 0.25}s`,
                animationDuration: `${2.2 + (index % 4) * 0.35}s`
              }}
            >
              <span className="asma-rocket-head" />
              <span className="asma-rocket-body" />
              <span className="asma-rocket-fire" />
            </div>
          ))}
        </div>

        <div className="asma-card asma-card-celebration">
          <h1>Happy Valentine My Love</h1>
          <p>You made my universe brighter today.</p>
        </div>
      </section>
    );
  }

  return (
    <section className="asma">
      <div className="asma-stars" aria-hidden="true" />
      <div className="asma-hearts" aria-hidden="true">
        {floatingHearts.map((_, index) => (
          <span
            key={index}
            className="asma-heart"
            style={{
              left: `${4 + index * 7}%`,
              animationDelay: `${(index % 7) * 0.45}s`,
              animationDuration: `${5.8 + (index % 5) * 0.7}s`
            }}
          >
            &#10084;
          </span>
        ))}
      </div>
      <div className="asma-glow asma-glow-left" aria-hidden="true" />
      <div className="asma-glow asma-glow-right" aria-hidden="true" />

      <div className="asma-card">
        <h1>
          Will you be my valentine <span className="asma-name">Asma</span>
        </h1>

        <div className="asma-actions">
          <button
            className="asma-btn asma-btn-yes"
            type="button"
            onClick={() => setAccepted(true)}
            style={{
              transform: `scale(${yesScale})`,
              zIndex: noHidden ? 3 : 2
            }}
          >
            Yes
          </button>

          <button
            className="asma-btn asma-btn-no"
            type="button"
            onClick={handleNo}
            style={{
              transform: `scale(${noScale})`,
              opacity: noHidden ? 0 : 1,
              pointerEvents: noHidden ? 'none' : 'auto'
            }}
          >
            No
          </button>
        </div>
      </div>
    </section>
  );
}

export default Asma;
